import { Component, OnDestroy, OnInit } from "@angular/core";
import { Ref } from "../../../dto";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { HttpFacetecService } from "src/app/service/http-facetec.service";
import { catchError } from "rxjs/operators";
import { ConfigService } from "src/app/service/config.service";
import { RefService } from "src/app/service/ref.service";
import { Config as FacetecConfig } from "../../../../../../assets/Config";
import { trackJourney } from "src/app/utils/utils";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { getLocalizedStrings } from "src/app/constants";
import { SessionRequestProcessor } from "src/app/service/SessionRequestProcessor";
import { SampleAppUtilities } from "src/app/service/utilities/SampleAppUtilities";
import { FaceTecSDKInstance } from "src/assets/core-sdk/FaceTecSDK.js/FaceTecPublicApi";
import { DeveloperStatusMessages } from "src/app/service/utilities/DeveloperStatusMessages";
import { FaceTecSDKServiceV10 } from "src/app/service/FaceTecSDKServiceV10";
import { FaceTecSDK } from "src/app/service/utilities/FaceTecSDKGlobal";
import { ThemeHelpers } from "src/app/service/utilities/ThemeHelpers";

// TODO: Remove all instances of instant nd convert to get
@Component({
    selector: "app-landing",
    templateUrl: "./landing.component.html",
    styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit, OnDestroy {
    status: string = "";
    sdkInitialised = true;
    direction = "ltr";

    private themeHelpers: ThemeHelpers = new ThemeHelpers();
    private faceTecSDKInstance!: FaceTecSDKInstance;

    private langChangeSubscription: Subscription | null = null;
    private lang: string = "en";

    constructor(
        private activatedRoute: ActivatedRoute,
        private httpService: HttpFacetecService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private configService: ConfigService,
        private refService: RefService,
        private router: Router,
        private translateService: TranslateService,
        private facetecSDKServiceV10: FaceTecSDKServiceV10,
    ) {
        console.log("LandingComponent constructor");
    }

    ngOnDestroy() {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }

    async initTranslations() {
        this.status = this.translateService.instant("validating_reference");
    }

    async ngOnInit() {
        this.initTranslations();

        console.log("Facetec SDK Version; ", FaceTecSDK.version());
        console.log("Increment Number: ", 1.12);

        this.langChangeSubscription = this.translateService.onLangChange.subscribe((event) => {
            this.direction = event.lang === "ar" || event.lang === "he" ? "rtl" : "ltr";
            this.initTranslations();
        });

        var ref: string | null = null;
        const _this = this;
        this.activatedRoute.queryParamMap.subscribe(async (params) => {
            ref = params.get("ref");
            const lang = params.get("lang") === "ar" ? "ar" : "en";

            _this.lang = lang;

            console.log("Using Language: ", lang);

            this.configService.setLanguage(lang);

            this.translateService.use(lang);
            document.documentElement.dir = this.isRTLLanguage(lang) ? "rtl" : "ltr";

            if (!ref) {
                this.toastr.error(
                    await this.translateService.get("invalid_reference_provided").toPromise(),
                    await this.translateService.get("error").toPromise(),
                );
                this.status = await this.translateService
                    .get("invalid_reference_provided")
                    .toPromise();
                return;
            }

            trackJourney({
                ref: ref,
                page: "landing_validate_ref_start",
                httpService: this.httpService,
            });

            var reference: Ref = {
                ref: ref,
            };

            this.spinner.show();
            this.httpService
                .validateRef(reference)
                .pipe(
                    catchError(async (error) => {
                        this.spinner.hide();
                        console.log("Error validating reference", error);
                        this.toastr.error(
                            error.statusText ? error.statusText : error.message,
                            await this.translateService.get("error").toPromise(),
                        );
                        this.status =
                            (await this.translateService
                                .get("error_occured_validating_reference")
                                .toPromise()) +
                            " " +
                            (error.statusText ? error.statusText : error.message);
                        throw error;
                    }),
                )
                .subscribe(async (result) => {
                    this.spinner.hide();
                    if (!result) {
                        this.toastr.error(
                            await this.translateService
                                .get("error_occured_validating_reference")
                                .toPromise(),
                            await this.translateService.get("error").toPromise(),
                        );
                        this.status = await this.translateService
                            .get("error_occured_validating_reference")
                            .toPromise();
                        return;
                    }

                    if (!result.status) {
                        this.toastr.error(
                            (await this.translateService
                                .get("error_occured_validating_reference")
                                .toPromise()) +
                                " " +
                                result.error,
                            await this.translateService.get("error").toPromise(),
                        );
                        this.status =
                            (await this.translateService
                                .get("error_occured_validating_reference")
                                .toPromise()) +
                            " " +
                            result.error;
                        return;
                    }

                    trackJourney({
                        ref: ref as string,
                        page: "landing_validate_ref_success",
                        httpService: this.httpService,
                    });
                    console.log("Reference validated successfully", result);
                    this.configService.setConfig(result.config);
                    this.refService.setRef(ref as string);

                    const config = this.configService.getConfig();
                    if (!config) {
                        this.toastr.error("Configuration not found");
                        return;
                    }

                    FacetecConfig.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT = config.url + "/process-request";
                    // FacetecConfig.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT =
                    //     "https://server.facetec.axonwireless.co.za/process-request";
                    console.log(
                        "URL set to [" +
                            FacetecConfig.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT +
                            "]",
                    );

                    if (config.deviceKeyIdentifier) {
                        FacetecConfig.DeviceKeyIdentifier = config.deviceKeyIdentifier;
                        console.log("Device Key Identifier set...");
                    }
                    if (config.publicFaceScanEncryptionKey) {
                        FacetecConfig.PublicFaceScanEncryptionKey =
                            config.publicFaceScanEncryptionKey;
                        console.log("Public Face Scan Encryption Key set...");
                    }
                    if (config.browserSdkLicense) {
                        FacetecConfig.ProductionKeyText = config.browserSdkLicense;
                        console.log("Production Key Text set...");
                    }
                    if (config.token) {
                        FacetecConfig.customServerAuthToken = config.token;
                        console.log("Custom Server Auth Token set...");
                    }

                    FacetecConfig.demonstrationExternalDatabaseRefID =
                        this.generateExternalDatabaseRefID();

                    FacetecConfig.customServerEnrollmentIdentifier =
                        FacetecConfig.demonstrationExternalDatabaseRefID;

                    console.log(
                        "Demonstration External Database Ref ID set to [" +
                            FacetecConfig.demonstrationExternalDatabaseRefID +
                            "]",
                    );

                    trackJourney({
                        ref: ref as string,
                        page: "sdk_initialize_browser_sdk_start",
                        httpService: this.httpService,
                    });
                    // this.facetecSDKService.initializeBrowserSDK({
                    //     onInitializeFailed: this.onInitializeFailed.bind(this),
                    //     onInitializeSuccess: this.onInitializeSuccess.bind(this),
                    // });

                    // Use absolute asset paths so SDK files resolve correctly under any route depth.
                    FaceTecSDK.setResourceDirectory("/assets/core-sdk/FaceTecSDK.js/resources");
                    FaceTecSDK.setImagesDirectory("/assets/core-sdk/FaceTec_images");
                    // Initialize FaceTec Browser SDK
                    // Required Parameters:
                    // - deviceKeyIdentifier:  The public Device Key Identifier associated with your Application
                    // - sessionRequestProcessor:  A SessionRequestProcessor class.  Please see the implementation of SessionRequestProcessor in this Sample App
                    // - callback:  A FaceTecInitializeCallback.
                    //      - The onSuccess callback is called with a FaceTecSDKInstance when successful.
                    //      - The onError callback is called when your SessionRequestProcessor cannot make a connection to your Server, or an invalid Device Key Identifier was used.
                    const _this = this;
                    FaceTecSDK.initializeWithSessionRequest(
                        FacetecConfig.DeviceKeyIdentifier,
                        new SessionRequestProcessor(_this.facetecSDKServiceV10),
                        {
                            onSuccess: function (newFaceTecSdkInstance) {
                                _this.faceTecSDKInstance = newFaceTecSdkInstance;
                                _this.facetecSDKServiceV10.setFaceTecSDKInstance(
                                    newFaceTecSdkInstance,
                                );
                                _this.onFaceTecSDKInitializationSuccess();
                            },
                            onError: function (initializationError) {
                                _this.onFaceTecSDKInitializationFailure(initializationError);
                            },
                        },
                    );
                });
        });
    }

    onFaceTecSDKInitializationSuccess = () => {
        SampleAppUtilities.setupAndFadeInMainUIOnInitializationSuccess();
        // Set your FaceTec Device SDK Customizations.
        this.themeHelpers.setAppTheme(this.themeHelpers.getCurrentTheme());
        // Set the sound files that are to be used for Vocal Guidance.
        SampleAppUtilities.setVocalGuidanceSoundFiles();
        // Set the strings to be used for group names, field names, and placeholder texts for the FaceTec ID Scan User OCR Confirmation Screen.
        SampleAppUtilities.setOCRLocalization();
        DeveloperStatusMessages.logAndDisplayMessage("Initialized Successfully.");

        trackJourney({
            ref: this.refService.getRef() as string,
            page: "sdk_initialize_browser_sdk_success",
            httpService: this.httpService,
        });

        getLocalizedStrings(this.lang).then((module) => {
            console.log("onFaceTecSDKInitializationSuccess :: 5", {
                ...module,
            });
            FaceTecSDK.configureLocalization({
                ...module,
            });
        });

        console.log("onInitializeSuccess");
        this.sdkInitialised = true;
        this.start();
    };
    // Handle initialization unsuccess
    onFaceTecSDKInitializationFailure = (initializationError: any) => {
        SampleAppUtilities.fadeInMainUIContainer();
        DeveloperStatusMessages.logInitializationErrorResult(initializationError);

        this.sdkInitialised = false;
    };

    start() {
        this.configService.setTryAgain(false);
        this.router.navigate(["/facetec"]);
    }

    generateExternalDatabaseRefID = (): string => {
        return `_zain_eshop_${this.refService.getRef()}_${SampleAppUtilities.generateUUId()}`;
    };

    private isRTLLanguage(lang: string): boolean {
        const rtlLanguages = ["ar", "he", "fa", "ur"];
        return rtlLanguages.includes(lang);
    }
}
